function Detail() {
  return <div>去home</div>;
}
export default Detail;
